import Button from '../../atoms/Button/Button';

import styles from './ItemListCardFooter.module.css';

/**
 * ItemListCardFooterLink - Footer link button for ItemListCard
 * @param {object} props
 * @param {string} props.href - Link URL
 * @param {string} props.label - Link label
 * @param {boolean} [props.targetBlank=false] - Open link in new tab
 * @returns {JSX.Element}
 */
function ItemListCardFooterLink({
  href,
  label,
  targetBlank = false,
}) {
  return (
    <Button
      color="no-background"
      size="small"
      iconPosition="right"
      icon="arrow-up-right-md"
    >
      <a
        href={href}
        className={styles.link}
        target={targetBlank ? '_blank' : undefined}
        rel={targetBlank ? 'noopener noreferrer' : undefined}
      >
        {label}
      </a>
    </Button>
  );
}

export default ItemListCardFooterLink;
